import { createApp } from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from 'vue-axios';
import Toaster from '@meforma/vue-toaster';
import ElementPlus from 'element-plus';
// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import { VueReCaptcha } from "vue-recaptcha-v3";
import "bootstrap";

import VueEasyLightbox from "vue-easy-lightbox";
import './assets/css/sb_masterLayout.css';
import 'element-plus/theme-chalk/index.css';
import './assets/css/style-new.css';

// 🔹 Analytics integrations
import './config/firebase'; // initializes Firebase app + analytics

import { formatDate } from './utils/dateFormat';
import { numericInput } from './utils/numericInput';
import { installAuthInterceptors } from './services/http';

// Token refresh / logout rules live in services/http.js. Installed before the
// router so the first navigation sees the reconciled login state.
installAuthInterceptors(store, router);


// import * as mdb from 'mdb-ui-kit'; // lib
const app = createApp(App);

app.use(VueAxios, axios)
  .use(router)
  .use(store)
  .use(Toaster)
  .use(ElementPlus)
  .use(VueReCaptcha, { siteKey: "6Lfy4A4pAAAAAHvlBbZ2tQdiKKCv6hON4b8QM1gL" })
  .use(VueEasyLightbox);

// 🔹 Add global auth helpers
app.config.globalProperties.$auth = {
  get user() {
    return store.getters["auth/getUserData"];
  },
  get loggedIn() {
    return store.getters["auth/getLoggedIn"];
  },
};

// 🔹 Global date display helper (yyyy-mm-dd -> dd/mm/yyyy)
app.config.globalProperties.$formatDate = formatDate;

// 🔹 Positive-number-only guard for amount style text inputs (v-numeric)
app.directive("numeric", numericInput);

app.mount("#app");


// 🔹 Restore user profile on refresh if logged in but data is missing
if (store.getters["auth/getLoggedIn"] && !store.getters["auth/getUserData"]) {
  store.dispatch("auth/refreshProfile").catch((err) => {
    console.error("Failed to restore session profile:", err);
  });
}